import React, { useState } from "react";
import { pointsConfig } from "../../pointsConfig";
import MilesRankDetailModal from "../../components/modal/milesPoints/milesRankDetailModal/MilesRankDetailModal";

function MilesLeaderBoardTopRankCard() {
  const [modal, setModal] = useState(false);
  return (
    <>
      <MilesRankDetailModal open={modal} setOpen={setModal} />
      <div
        className="w-[32%] h-64 bg-white rounded-xl flex flex-col items-center relative cursor-pointer"
        onClick={() => setModal(true)}
      >
        <img
          src="/1stTag.svg"
          alt=""
          className="absolute right-0 top-5 h-14 object-contain"
        />
        <div className="flex flex-col flex-1 w-full items-center mt-4">
          <img
            src={pointsConfig.ranks.legendary.icon}
            alt=""
            className="w-24 object-contain"
          />
          <span className="font-BrFirmaBold text-xl">Company name here</span>
          <span className="text-[#606060]">
            {pointsConfig.ranks.legendary.label}
          </span>
        </div>
        <div className="h-16 flex w-full items-center justify-center border-t border-gray-300 max-w-[90%] mb-2">
          <img src="/goldCoin.png" alt="" className="w-6 object-contain" />
          <span className="text-[#606060] text-xl ml-1">10,455</span>
        </div>
      </div>
    </>
  );
}

export default MilesLeaderBoardTopRankCard;
